import Vue from "vue";
import objectToForm from '@/utils/objectToForm'
// import purchaseOrdersTransformer from "@/transformers/purchase/completeOCs";

function dataTransformer({
  invoice_pdf,
  invoice_xml
}) {
  let dataTransformed = {
    pdf_file: invoice_pdf,
    xml_file: invoice_xml
  }
  return objectToForm(dataTransformed)
}

export default (data) => {
  const payload = dataTransformer(data);
  return Vue.$http
    .post('taxreceipt/taxreceipt/freight/calculate/price/', payload)
    .then(({ data }) => {
      return data
    })
    .catch((error) => {
      const response = error.response
      if (response && response.status !== 404) {
        throw error
      } 
    })
};


// WEBPACK FOOTER //
// ./src/services/purchase/fetchFreightSubtotal.js